<template>
    <section class="delivery-sec__body" v-if="this.$store.state.settings.site_id === 1">
        <PrivacyPolicyRu/>
    </section>
    <section class="delivery-sec__body" v-else-if="this.$store.state.settings.site_id === 2">
        <PrivacyPolicyEn/>
    </section>

</template>

<script>
import PrivacyPolicyRu from './ru/privacy-policy.vue'
import PrivacyPolicyEn from './en/privacy-policy.vue'
export default {
    components:{
        PrivacyPolicyRu,PrivacyPolicyEn
    },
    name: "privacy-policy"
}
</script>

<style scoped>

</style>
